import apisauce from 'apisauce';
import storage from 'redux-persist/lib/storage';

const chatbotApiInstance = apisauce.create({
  baseURL: process.env.REACT_APP_CHATBOT_ENDPOINT,
  headers: {
    'Cache-Control': 'no-cache',
  },
  timeout: 30000,
});

// Inject the logged-in user's auth token on every request, mirroring the main
// API client (services/Api.js). The token is persisted at login under the
// `authHeaders` key (see sagas/UserAccountSagas.js) as `{ authorization: 'Bearer <token>' }`.
const authRequestTransform = request => async () => {
  const storageHeaders = await storage.getItem('authHeaders');
  if (!storageHeaders) return;

  const headers = JSON.parse(storageHeaders);
  chatbotApiInstance.setHeaders(headers);
  request.headers = { ...request.headers, ...headers };
};

chatbotApiInstance.addAsyncRequestTransform(authRequestTransform);

export const chatMessage = body => chatbotApiInstance.post('/chat/message', body);
export const chatConfirm = body => chatbotApiInstance.post('/chat/confirm', body);
export const chatReset   = body => chatbotApiInstance.post('/chat/reset', body);
